import {RequestKindResponse} from "@/types/service-response";
import i18n from "@/i18n";

export default class RequestKindList {
  private constructor(
    readonly name: string,
    readonly label: string
  ) {}

  get requestName(): string {
    return i18n.t(`smartLinkPage.${this.name}`).toString()
  }


  static createFromResponse(responseData: RequestKindResponse): RequestKindList {
    return new RequestKindList(
        responseData.name,
        i18n.t(`smartLinkPage.${responseData.name}`).toString()
    )
  }

  static createFromResponseList(responseData: RequestKindResponse[]): RequestKindList[] {
    return responseData.map((item:RequestKindResponse) => {
      return new RequestKindList(
          item.name,
          i18n.t(`smartLinkPage.${item.name}`).toString()
      )
    })
  }
}